import Main from './page/Main';
import './styles/style.css';

const App = () => {
  return <Main />;
};

export default App;
